<template>
    <div class="store-management">
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            :close-on-click-modal="false"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{dialog.title}}
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="门店名称: " prop="storeName">
                    <el-input v-model="dialog.content.storeName" placeholder="请输入门店名称"></el-input>
                </el-form-item>
                <el-form-item label="门店Slogan: " prop="storeSlogan">
                    <el-input v-model="dialog.content.storeSlogan" placeholder="门店Slogan"></el-input>
                </el-form-item>
                <el-form-item label="门店地址: " prop="address">
                    <el-input v-model="dialog.content.address" placeholder="请输入门店地址"></el-input>
                </el-form-item>
                <el-form-item label="门店门锁: " prop="gateLock">
                    <el-input v-model="dialog.content.gateLock" placeholder="请输入门店门锁"></el-input>
                </el-form-item>
                <el-form-item label="门店介绍: " prop="storeDetail">
                    <el-input type="textarea" v-model="dialog.content.storeDetail" placeholder="请输入门店介绍"></el-input>
                </el-form-item>
                <el-form-item label="用户须知: " prop="storeNotification">
                    <el-input type="textarea" v-model="dialog.content.storeNotification" placeholder="请输入用户须知"></el-input>
                </el-form-item>
                <el-form-item label="门店封面图: " prop="coverUrl">
                    <el-upload
                        :action="imageUploadUrl"
                        :headers="{'X-token': token}"
                        :show-file-list="false"
                        :on-success="handleUploadSuccess">
                        <el-button type="primary" size="small">
                            <i class="el-icon-plus"></i>
                            选择图片
                        </el-button>
                    </el-upload>
                    <img :style="{
                        'width': '100%'
                    }" v-if="dialog.content.coverUrl != ''" :src="'https://www.7amdancestudio.cn/image/' + dialog.content.coverUrl">
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>
        <div class="el-card-title">
            <span>门店列表</span>
            <div :style="{ display: 'flex' }">
                <el-tooltip effect="dark" content="新增门店" placement="top">
                    <el-button type="text" @click="handleStoreInsert">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 640
        }">
            <template slot="isOpen" slot-scope="item">
                <el-switch
                    :active-value="'true'"
                    :inactive-value="'false'"
                    @change="handleOpen(item.data.row)"
                    :value="item.data.row.isOpen">
                </el-switch>
            </template>
            <template slot="coverUrl" slot-scope="item">
                <img v-if="item.data.row.coverUrl" 
                    :src="'https://www.7amdancestudio.cn/image/' + item.data.row.coverUrl"
                    :style="{'width': '20rem'}">
                <span v-else>-</span>
            </template>
            <template slot="operation" slot-scope="item">
                <el-button type="text" size="small" @click="handleStoreEdit(item.data.row)">编辑</el-button>
            </template>
        </custom-table>
    </div>
</template>

<script>
import { StoreManagementApi } from '../http/storeManagement/storeManagement';
import { FileApi } from '../http/file';
import CustomTable from '../components/customTable.vue';
export default {
    name: "store-management",
    components: {
        CustomTable
    },
    data(){
        return {
            tableData: {
                data: [],
                columns: [],
                tableLoading: false
            },
            dialog: {
                title: "",
                visible: false,
                type: "",
                content: {
                    address: "",
                    coverUrl: "",
                    isOpen: "false",
                    storeId: "",
                    storeName: "",
                    storeSlogan: "",
                    storeDetail: "",
                    storeNotification: "",
                    gateLock: ""
                }
            },
            imageUploadUrl: FileApi.imageUpload,
            // 认证token
            token: ""
        }
    },
    mounted(){
        this.token = localStorage.getItem('authToken');
        this.getStoreList();
    },
    methods: {
        getStoreList(){
            this.tableData.tableLoading = true;
            StoreManagementApi.getStoreList().then(res => {
                this.tableData.tableLoading = false;
                Object.assign(this.tableData, res);
            })
        },
        handleCancel(){
            this.dialog.visible = false;
            for(let key in this.dialog.content){
                this.dialog.content[key] = "";
            }
        },
        handleStoreEdit(row){
            this.dialog.visible = true;
            this.dialog.title = "编辑门店";
            this.dialog.type = 'edit';
            for(let key in this.dialog.content){
                this.dialog.content[key] = row[key];
            }
        },
        handleStoreInsert(){
            this.dialog.visible = true;
            this.dialog.title = "新增门店";
            this.dialog.type = 'insert';
        },
        handleUploadSuccess(res){
            this.dialog.content.coverUrl = res.content;
        },
        handleOpen(item){
            this.$confirm('是否修改该门店的开业状态?', '修改状态', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                for(let key in this.dialog.content){
                    this.dialog.content[key] = item[key];
                }
                const isOpen = !(item.isOpen === 'false')
                this.dialog.content.isOpen = !isOpen + '';
                StoreManagementApi.updateStore(this.dialog.content).then(res => {
                    if(res.data.status === 200){
                        this.$notify.success({title: "修改门店状态成功"});
                        this.handleCancel();
                        this.getStoreList();
                    }
                })
            }).catch(() => {});
        },
        submit(){
            StoreManagementApi[this.dialog.type === 'insert' ? 'insertStore' : 'updateStore'](this.dialog.content).then(res => {
                if(res.data.status === 200){
                    this.$notify.success({ title: this.dialog.type === 'insert' ? '新增门店成功': '编辑门店成功'});
                    this.handleCancel();
                    this.getStoreList();
                }
            })
        }
    }
}
</script>

<style lang="less">
div.store-management{
    // padding: 14px 20px;
}
</style>